/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { CallModel } from '../models/CallModel';
import type { CommentInput } from '../models/CommentInput';
import type { CommentResponse } from '../models/CommentResponse';
import type { ConnectAiToLeadRequest } from '../models/ConnectAiToLeadRequest';
import type { CustomerDetailResponse } from '../models/CustomerDetailResponse';
import type { LeadBusinessTypeEnum } from '../models/LeadBusinessTypeEnum';
import type { LeadFilterEvent } from '../models/LeadFilterEvent';
import type { LeadModelPagedListData } from '../models/LeadModelPagedListData';
import type { LeadRemoveRequest } from '../models/LeadRemoveRequest';
import type { LeadRequest } from '../models/LeadRequest';
import type { LeadResponse } from '../models/LeadResponse';
import type { LeadsAttentionCommentDtoPagedListData } from '../models/LeadsAttentionCommentDtoPagedListData';
import type { LeadsAttentionCommentRequest } from '../models/LeadsAttentionCommentRequest';
import type { LeadSourceDto } from '../models/LeadSourceDto';
import type { LeadSourceDtoInput } from '../models/LeadSourceDtoInput';
import type { LeadSourceListDtoPagedListData } from '../models/LeadSourceListDtoPagedListData';
import type { LeadStatisticsDto } from '../models/LeadStatisticsDto';
import type { LeadStatusEnum } from '../models/LeadStatusEnum';
import type { LeadTabEnum } from '../models/LeadTabEnum';
import type { LeadTypeDto } from '../models/LeadTypeDto';
import type { SetDefaultContactTypeRequest } from '../models/SetDefaultContactTypeRequest';
import type { SortTypeEnum } from '../models/SortTypeEnum';
import type { UpdateAiAnswereStateRequest } from '../models/UpdateAiAnswereStateRequest';

import type { CancelablePromise } from '../core/CancelablePromise';
import { OpenAPI } from '../core/OpenAPI';
import { request as __request } from '../core/request';

export class LeadService {

  /**
   * @param dateFrom 
   * @param dateTo 
   * @param business
 *
 * 0 = Showroom
 *
 * 1 = Service
   * @param tab
 *
 * 0 = Other
 *
 * 1 = Valuation
 *
 * 2 = MAIA
   * @param branchId 
   * @param status
 *
 * 0 = Empty
 *
 * 1 = Active
 *
 * 2 = LostSales
 *
 * 3 = FutureProspecting
 *
 * 4 = Dealt
 *
 * 5 = Call
 *
 * 6 = Invalid
 *
 * 7 = HotLead
 *
 * 8 = Appointed
 *
 * 9 = ColdLead
 *
 * 10 = Dublicate
   * @param days 
   * @param onlyMy 
   * @param ownerId 
   * @param hasAttentionComments 
   * @param sort 
   * @param order
 *
 * 0 = ASC
 *
 * 1 = DESC
   * @param leadId 
   * @param customerName 
   * @param leadTypeIds 
   * @param events 
   * @param skipPagination Пропустить пагинацию
   * @param page Страница
   * @param maxCount Максимально количество записей на странице
   * @returns LeadModelPagedListData Success
   * @throws ApiError
   */
  public static getLeadGetList(
dateFrom?: string,
dateTo?: string,
business?: LeadBusinessTypeEnum,
tab?: LeadTabEnum,
branchId?: number,
status?: LeadStatusEnum,
days?: number,
onlyMy?: boolean,
ownerId?: number,
hasAttentionComments?: boolean,
sort?: string,
order?: SortTypeEnum,
leadId?: number,
customerName?: string,
leadTypeIds?: Array<number>,
events?: Array<LeadFilterEvent>,
skipPagination?: boolean,
page?: number,
maxCount?: number,
): CancelablePromise<LeadModelPagedListData> {
    return __request(OpenAPI, {
      method: 'GET',
      url: '/Lead/GetList',
      query: {
        'DateFrom': dateFrom,
        'DateTo': dateTo,
        'Business': business,
        'Tab': tab,
        'BranchId': branchId,
        'Status': status,
        'Days': days,
        'OnlyMy': onlyMy,
        'OwnerId': ownerId,
        'HasAttentionComments': hasAttentionComments,
        'Sort': sort,
        'Order': order,
        'LeadId': leadId,
        'CustomerName': customerName,
        'LeadTypeIds': leadTypeIds,
        'Events': events,
        'SkipPagination': skipPagination,
        'Page': page,
        'MaxCount': maxCount,
      },
      errors: {
        400: `Bad Request`,
        500: `Server Error`,
      },
    });
  }

  /**
   * @param id 
   * @returns LeadResponse Success
   * @throws ApiError
   */
  public static getGetLead(
id?: number,
): CancelablePromise<LeadResponse> {
    return __request(OpenAPI, {
      method: 'GET',
      url: '/GetLead',
      query: {
        'id': id,
      },
      errors: {
        400: `Bad Request`,
        500: `Server Error`,
      },
    });
  }

  /**
   * @param requestBody 
   * @returns number Success
   * @throws ApiError
   */
  public static postLeadCreateOrUpdateLead(
requestBody?: LeadRequest,
): CancelablePromise<number> {
    return __request(OpenAPI, {
      method: 'POST',
      url: '/Lead/CreateOrUpdateLead',
      body: requestBody,
      mediaType: 'application/json-patch+json',
      errors: {
        400: `Bad Request`,
        500: `Server Error`,
      },
    });
  }

  /**
   * @param phones 
   * @param codes 
   * @returns any Success
   * @throws ApiError
   */
  public static getLeadGetCalls(
phones?: Array<string>,
codes?: Array<string>,
): CancelablePromise<any> {
    return __request(OpenAPI, {
      method: 'GET',
      url: '/Lead/GetCalls',
      query: {
        'phones': phones,
        'codes': codes,
      },
    });
  }

  /**
   * @param dateFrom 
   * @param dateTo 
   * @param business
 *
 * 0 = Showroom
 *
 * 1 = Service
   * @param tab
 *
 * 0 = Other
 *
 * 1 = Valuation
 *
 * 2 = MAIA
   * @param branchId 
   * @param status
 *
 * 0 = Empty
 *
 * 1 = Active
 *
 * 2 = LostSales
 *
 * 3 = FutureProspecting
 *
 * 4 = Dealt
 *
 * 5 = Call
 *
 * 6 = Invalid
 *
 * 7 = HotLead
 *
 * 8 = Appointed
 *
 * 9 = ColdLead
 *
 * 10 = Dublicate
   * @param days 
   * @param onlyMy 
   * @param ownerId 
   * @param hasAttentionComments 
   * @param sort 
   * @param order
 *
 * 0 = ASC
 *
 * 1 = DESC
   * @param leadId 
   * @param customerName 
   * @param leadTypeIds 
   * @param events 
   * @param skipPagination Пропустить пагинацию
   * @param page Страница
   * @param maxCount Максимально количество записей на странице
   * @returns LeadStatisticsDto Success
   * @throws ApiError
   */
  public static getLeadStatistics(
dateFrom?: string,
dateTo?: string,
business?: LeadBusinessTypeEnum,
tab?: LeadTabEnum,
branchId?: number,
status?: LeadStatusEnum,
days?: number,
onlyMy?: boolean,
ownerId?: number,
hasAttentionComments?: boolean,
sort?: string,
order?: SortTypeEnum,
leadId?: number,
customerName?: string,
leadTypeIds?: Array<number>,
events?: Array<LeadFilterEvent>,
skipPagination?: boolean,
page?: number,
maxCount?: number,
): CancelablePromise<LeadStatisticsDto> {
    return __request(OpenAPI, {
      method: 'GET',
      url: '/Lead/Statistics',
      query: {
        'DateFrom': dateFrom,
        'DateTo': dateTo,
        'Business': business,
        'Tab': tab,
        'BranchId': branchId,
        'Status': status,
        'Days': days,
        'OnlyMy': onlyMy,
        'OwnerId': ownerId,
        'HasAttentionComments': hasAttentionComments,
        'Sort': sort,
        'Order': order,
        'LeadId': leadId,
        'CustomerName': customerName,
        'LeadTypeIds': leadTypeIds,
        'Events': events,
        'SkipPagination': skipPagination,
        'Page': page,
        'MaxCount': maxCount,
      },
      errors: {
        400: `Bad Request`,
        500: `Server Error`,
      },
    });
  }

  /**
   * @returns LeadTypeDto Success
   * @throws ApiError
   */
  public static getLeadTypes(): CancelablePromise<Array<LeadTypeDto>> {
    return __request(OpenAPI, {
      method: 'GET',
      url: '/Lead/Types',
      errors: {
        400: `Bad Request`,
        500: `Server Error`,
      },
    });
  }

  /**
   * @param leadId 
   * @returns CustomerDetailResponse Success
   * @throws ApiError
   */
  public static getLeadCustomerDetail(
leadId?: number,
): CancelablePromise<CustomerDetailResponse> {
    return __request(OpenAPI, {
      method: 'GET',
      url: '/Lead/CustomerDetail',
      query: {
        'leadId': leadId,
      },
      errors: {
        400: `Bad Request`,
        500: `Server Error`,
      },
    });
  }

  /**
   * @param leadId 
   * @param skipPagination Пропустить пагинацию
   * @param page Страница
   * @param maxCount Максимально количество записей на странице
   * @returns LeadsAttentionCommentDtoPagedListData Success
   * @throws ApiError
   */
  public static getLeadAttentionComment(
leadId?: number,
skipPagination?: boolean,
page?: number,
maxCount?: number,
): CancelablePromise<LeadsAttentionCommentDtoPagedListData> {
    return __request(OpenAPI, {
      method: 'GET',
      url: '/Lead/AttentionComment',
      query: {
        'LeadId': leadId,
        'SkipPagination': skipPagination,
        'Page': page,
        'MaxCount': maxCount,
      },
      errors: {
        400: `Bad Request`,
        500: `Server Error`,
      },
    });
  }

  /**
   * @param requestBody 
   * @returns boolean Success
   * @throws ApiError
   */
  public static postLeadCreateAttentionComment(
requestBody?: LeadsAttentionCommentRequest,
): CancelablePromise<boolean> {
    return __request(OpenAPI, {
      method: 'POST',
      url: '/Lead/CreateAttentionComment',
      body: requestBody,
      mediaType: 'application/json-patch+json',
      errors: {
        400: `Bad Request`,
        500: `Server Error`,
      },
    });
  }

  /**
   * @param id 
   * @returns boolean Success
   * @throws ApiError
   */
  public static postLeadCloseAttentionComment(
id?: number,
): CancelablePromise<boolean> {
    return __request(OpenAPI, {
      method: 'POST',
      url: '/Lead/CloseAttentionComment',
      query: {
        'id': id,
      },
      errors: {
        400: `Bad Request`,
        500: `Server Error`,
      },
    });
  }

  /**
   * @param id 
   * @param skipPagination Пропустить пагинацию
   * @param page Страница
   * @param maxCount Максимально количество записей на странице
   * @returns CommentResponse Success
   * @throws ApiError
   */
  public static getLeadGetNotes(
id: number,
skipPagination?: boolean,
page?: number,
maxCount?: number,
): CancelablePromise<CommentResponse> {
    return __request(OpenAPI, {
      method: 'GET',
      url: '/Lead/GetNotes',
      query: {
        'Id': id,
        'SkipPagination': skipPagination,
        'Page': page,
        'MaxCount': maxCount,
      },
      errors: {
        400: `Bad Request`,
        500: `Server Error`,
      },
    });
  }

  /**
   * @param requestBody 
   * @returns any Success
   * @throws ApiError
   */
  public static postLeadAddNote(
requestBody?: CommentInput,
): CancelablePromise<any> {
    return __request(OpenAPI, {
      method: 'POST',
      url: '/Lead/AddNote',
      body: requestBody,
      mediaType: 'application/json-patch+json',
      errors: {
        400: `Bad Request`,
        500: `Server Error`,
      },
    });
  }

  /**
   * @param id 
   * @param priority 
   * @returns any Success
   * @throws ApiError
   */
  public static postLeadsNotificationsNew(
id: number,
priority: number = 1,
): CancelablePromise<any> {
    return __request(OpenAPI, {
      method: 'POST',
      url: '/leads/{id}/notifications/new',
      path: {
        'id': id,
      },
      query: {
        'priority': priority,
      },
    });
  }

  /**
   * @param requestBody 
   * @returns any Success
   * @throws ApiError
   */
  public static deleteLead(
requestBody?: LeadRemoveRequest,
): CancelablePromise<any> {
    return __request(OpenAPI, {
      method: 'DELETE',
      url: '/Lead',
      body: requestBody,
      mediaType: 'application/json-patch+json',
    });
  }

  /**
   * @param id 
   * @returns CallModel Success
   * @throws ApiError
   */
  public static getLeadLeadCalls(
id: number,
): CancelablePromise<Array<CallModel>> {
    return __request(OpenAPI, {
      method: 'GET',
      url: '/Lead/LeadCalls/{id}',
      path: {
        'id': id,
      },
      errors: {
        400: `Bad Request`,
        500: `Server Error`,
      },
    });
  }

  /**
   * @param leadId 
   * @param enquiryCrmId 
   * @returns boolean Success
   * @throws ApiError
   */
  public static putLeadBindEnquiryCrm(
leadId: number,
enquiryCrmId: number,
): CancelablePromise<boolean> {
    return __request(OpenAPI, {
      method: 'PUT',
      url: '/Lead/BindEnquiryCrm/{leadId}/{enquiryCrmId}',
      path: {
        'leadId': leadId,
        'enquiryCrmId': enquiryCrmId,
      },
      errors: {
        400: `Bad Request`,
        500: `Server Error`,
      },
    });
  }

  /**
   * @param requestBody 
   * @returns boolean Success
   * @throws ApiError
   */
  public static putLeadEnableAi(
requestBody?: ConnectAiToLeadRequest,
): CancelablePromise<boolean> {
    return __request(OpenAPI, {
      method: 'PUT',
      url: '/Lead/EnableAi',
      body: requestBody,
      mediaType: 'application/json-patch+json',
      errors: {
        400: `Bad Request`,
        500: `Server Error`,
      },
    });
  }

  /**
   * @param requestBody 
   * @returns boolean Success
   * @throws ApiError
   */
  public static putLeadUpdateAiAnswereState(
requestBody?: UpdateAiAnswereStateRequest,
): CancelablePromise<boolean> {
    return __request(OpenAPI, {
      method: 'PUT',
      url: '/Lead/UpdateAiAnswereState',
      body: requestBody,
      mediaType: 'application/json-patch+json',
      errors: {
        400: `Bad Request`,
        500: `Server Error`,
      },
    });
  }

  /**
   * @param requestBody 
   * @returns boolean Success
   * @throws ApiError
   */
  public static putLeadDefaultAiContactType(
requestBody?: SetDefaultContactTypeRequest,
): CancelablePromise<boolean> {
    return __request(OpenAPI, {
      method: 'PUT',
      url: '/Lead/DefaultAiContactType',
      body: requestBody,
      mediaType: 'application/json-patch+json',
      errors: {
        400: `Bad Request`,
        500: `Server Error`,
      },
    });
  }

  /**
   * @param requestBody 
   * @returns number Created
   * @throws ApiError
   */
  public static postLeadSources(
requestBody?: LeadSourceDtoInput,
): CancelablePromise<number> {
    return __request(OpenAPI, {
      method: 'POST',
      url: '/Lead/sources',
      body: requestBody,
      mediaType: 'application/json-patch+json',
      errors: {
        400: `Bad Request`,
        500: `Server Error`,
      },
    });
  }

  /**
   * @param leadId 
   * @returns LeadSourceDto Success
   * @throws ApiError
   */
  public static getLeadSources(
leadId?: number,
): CancelablePromise<Array<LeadSourceDto>> {
    return __request(OpenAPI, {
      method: 'GET',
      url: '/Lead/sources',
      query: {
        'leadId': leadId,
      },
      errors: {
        400: `Bad Request`,
        500: `Server Error`,
      },
    });
  }

  /**
   * @param dateFrom 
   * @param dateTo 
   * @param customer 
   * @param source 
   * @param skipPagination Пропустить пагинацию
   * @param page Страница
   * @param maxCount Максимально количество записей на странице
   * @returns LeadSourceListDtoPagedListData Success
   * @throws ApiError
   */
  public static getLeadGetLeadSourceList(
dateFrom?: string,
dateTo?: string,
customer?: string,
source?: string,
skipPagination?: boolean,
page?: number,
maxCount?: number,
): CancelablePromise<LeadSourceListDtoPagedListData> {
    return __request(OpenAPI, {
      method: 'GET',
      url: '/Lead/get-lead-source-list',
      query: {
        'DateFrom': dateFrom,
        'DateTo': dateTo,
        'Customer': customer,
        'Source': source,
        'SkipPagination': skipPagination,
        'Page': page,
        'MaxCount': maxCount,
      },
      errors: {
        400: `Bad Request`,
        500: `Server Error`,
      },
    });
  }

}
